import { createFileRoute } from '@tanstack/react-router';
import AuthenticateRoute from 'src/components/organisms/app-layouts/authenticate-route/authenticate-route';
import { EmployeeExecutionPage } from 'src/modules/automations/components/pages/employees/executions/execution.page';
import {
  executionSearchSchema,
  executionPathSchema,
} from 'src/modules/automations/schemas/employees/executions.schema';

export const Route = createFileRoute(
  '/employees/$employeeId/executions/$executionId'
)({
  component: ExecutionDetailComponent,
  validateSearch: (search) => executionSearchSchema.parse(search),
  params: {
    parse: (params) => executionPathSchema.parse(params),
  },
});

function ExecutionDetailComponent() {
  const { employeeId, executionId } = Route.useParams();

  return (
    <AuthenticateRoute>
      <EmployeeExecutionPage
        employeeId={employeeId}
        executionId={executionId}
      />
    </AuthenticateRoute>
  );
}
